
export function uploadToS3(
  signedUrl: string,
  file: File,
  contentType: string,
  uploadInstructions?: { headers: Record<string, string> }
): Promise<boolean> {
  return new Promise((resolve) => {
    const xhr = new XMLHttpRequest();

    xhr.open('PUT', signedUrl, true);
    xhr.setRequestHeader('Content-Type', contentType);
    if (uploadInstructions?.headers['Content-Length']) {
      xhr.setRequestHeader('Content-Length', uploadInstructions.headers['Content-Length']);
    }
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) { 
        resolve(true);
      } else {
        console.error('Upload failed:', xhr.status, xhr.responseText);
        resolve(false);
      }
    };

    xhr.onerror = () => {
      console.error('Upload network error');
      resolve(false);
    };

    // Optional: Track upload progress
    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) {
        const percent = Math.round((event.loaded / event.total) * 100); 
      }
    };

    xhr.send(file);
  });
}

// Delete file from aws
export const deleteFileOnAwsAPI = async (fileURL: string) => {
  try {
    const response = await fetch(fileURL, { method: 'DELETE' });
    if (!response.ok) {
      throw new Error(`Delete failed: ${response.status}`);
    }
    return response;
  } catch (error: any) {
    console.error('Delete Error:', error.message);
    throw error;
  }
};